import { createFileRoute } from "@tanstack/react-router";
import { ThemeProvider } from "@repo/mfe-core";
import SsoEditPage from "../../../../pages/SsoSettings/components/SsoEditPage";

export const Route = createFileRoute("/admin/settings/sso-settings/edit")({
  component: () => (
    <ThemeProvider>
      <SsoEditPage />
    </ThemeProvider>
  ),
});
